import { Icon } from '@chakra-ui/react';

export const FiltersIcon = (props: any) => (
  <Icon aria-label="filters icon" {...props}>
    <path
      d="M7,4 C7.55228475,4 8,4.44771525 8,5 L8,6 L9,6 L9,9 L8,9 L8,19 C8,19.5522847 7.55228475,20 7,20 C6.44771525,20 6,19.5522847 6,19 L6,9 L5,9 L5,6 L6,6 L6,5 C6,4.44771525 6.44771525,4 7,4 Z M12,4 C12.5522847,4 13,4.44771525 13,5 L13,12 L14,12 L14,15 L13,15 L13,19 C13,19.5522847 12.5522847,20 12,20 C11.4477153,20 11,19.5522847 11,19 L11,15 L10,15 L10,12 L11,12 L11,5 C11,4.44771525 11.4477153,4 12,4 Z M17,4 C17.5522847,4 18,4.44771525 18,5 L18,9 L19,9 L19,12 L18,12 L18,19 C18,19.5522847 17.5522847,20 17,20 C16.4477153,20 16,19.5522847 16,19 L16,12 L15,12 L15,9 L16,9 L16,5 C16,4.44771525 16.4477153,4 17,4 Z"
      fill="currentColor"
    />
  </Icon>
);
